module.exports = __webpack_public_path__ + "assets/img/box8-img.3017b28a.png";